'use client';

import { useLocale } from 'next-intl';
import { useEffect } from 'react';

export function LocaleAttributes({ children }: { children: React.ReactNode }) {
  const locale = useLocale();
  const isRtl = locale === 'ar';

  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  }, [locale, isRtl]);

  return <>{children}</>;
}
